import React from 'react'

const DescendantOfMapContext = React.createContext(false)

export default DescendantOfMapContext
